import { motion } from 'framer-motion';

export default function CTA() {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-96 h-96 bg-gradient-to-br from-brand-green/20 to-transparent rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-gradient-to-br from-brand-beige/40 to-transparent rounded-full blur-3xl animate-pulse delay-300"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-5xl md:text-7xl font-caprasimo mb-6 text-brand-black leading-tight">
            Bereit für Ihre digitale Verkaufsmaschine?
          </h2>
          <p className="text-xl text-brand-grey mb-12 max-w-3xl mx-auto">
            Lassen Sie uns gemeinsam Ihre Webseite in ein leistungsstarkes Verkaufsinstrument mit AI-Power verwandeln
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <a 
              href="/contact" 
              className="w-full sm:w-auto bg-brand-green hover:bg-brand-green-light text-white px-6 sm:px-10 py-4 sm:py-5 rounded-lg text-lg font-semibold transition-all cursor-pointer whitespace-nowrap shadow-lg min-h-[44px] flex items-center justify-center"
            >
              Kostenloses Erstgespräch
            </a>
            <a 
              href="tel:01623651571" 
              className="w-full sm:w-auto bg-brand-beige-light hover:bg-brand-beige text-brand-black px-6 sm:px-10 py-4 sm:py-5 rounded-lg text-lg font-semibold transition-all cursor-pointer whitespace-nowrap border border-brand-beige flex items-center justify-center gap-3 min-h-[44px]"
            >
              <i className="ri-phone-line"></i>
              0162 365 1571
            </a>
          </div>

          <p className="mt-8 text-brand-grey">
            Unverbindlich &bull; Kostenlose Beratung &bull; Innerhalb von 24h Rückmeldung
          </p>
        </motion.div>
      </div>
    </section>
  );
}